import React, { FC, ReactNode } from 'react'
import s from './AdvertBadge.module.sass'
import { useCurrentSize } from '@shared/lib/helpers/classes'

interface Props {
  children?: ReactNode
  className?: string
  sizes: '62x23' | '54x19' | '42x18'
}

const AdvertBadge: FC<Props> = ({ children, sizes, className = '' }) => {
  const [size] = useCurrentSize(sizes)

  return (
    <span className={`${s.badge} ${className}`} data-size={size}>
      {children || <p className={s.text}>Реклама</p>}
    </span>
  )
}

export default AdvertBadge
